export const globalStyleTokens = {
  telephoneLinkUnderline: 'underline',
  focusVisible: '0px 0px 0px 2px #FFF, 0px 0px 0px 4px #000',
  strongFontFamily:
    '"GT Ultra Standard Bold", "GT Ultra Standard Bold Fallback", "Times New Roman", serif',
};

export const inputTokens = {
  borderDefault: 'brandTwo100',
  borderValid: 'brandTwo100',
  borderSize: '1px',
};

export const pageTokens = {
  borderRadius: 'xLarge',
  buyWithConfidenceBackgroundColor: 'brandOne120',
  includeSummaryWord: false,
  includeAddAPet: false,
  useHeroHeading: true,
  useAnnualWord: true,
  coverTypesToCheck: ['gold', 'silver'],
  paymentPageWhichDisclaimerPosition: 'inside',
};
